import { groupBy } from '@cx-modules/utils';

import { type BetsWithBestOdds } from '../types';

interface GroupedBetsProps {
  betsWithBestOdds: BetsWithBestOdds;
  visibleBetsNumber: number;
}

type GroupedBets = Record<string, BetsWithBestOdds>;

interface GroupedBetsResponse {
  canBeGrouped: boolean;
  totalGroupedBets: GroupedBets;
  visibleGroupedBets: GroupedBets;
}

export const useGroupedBets = ({ betsWithBestOdds, visibleBetsNumber }: GroupedBetsProps): GroupedBetsResponse => {
  const canBeGrouped = betsWithBestOdds.some(b => b?.line?.name !== null && typeof b?.line?.name !== 'undefined');

  const totalGroupedBets: GroupedBets = canBeGrouped ? groupBy(betsWithBestOdds, b => b.name) : {};

  const numberOfGroupedBetsColumns = Object.keys(totalGroupedBets).length;

  const visibleGroupedBets = Object.entries(totalGroupedBets).reduce((obj: GroupedBets, key) => {
    const arr = totalGroupedBets[key[0]].slice(0, Math.floor(visibleBetsNumber / numberOfGroupedBetsColumns));
    obj[key[0]] = arr;
    return obj;
  }, {});

  return {
    canBeGrouped,
    totalGroupedBets,
    visibleGroupedBets,
  };
};
